import React from 'react';

interface Props {
  width?: string;
  height?: string;
}

const NewSvg: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      width={width ?? '23'}
      height={height ?? '9'}
      viewBox='0 0 23 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 0.488281H1.69505L4.38453 5.10542H4.41843V0.488281H6.24909V8.48828H4.54274L1.86456 3.87114H1.81936V8.48828H0V0.488281Z'
        fill='white'
      />
      <path
        d='M12.2511 8.48828H7.24502V0.488281H12.1381V2.08828H9.06438V3.59685H11.5505V5.12828H9.06438V6.88828H12.2511V8.48828Z'
        fill='white'
      />
      <path
        d='M18.7511 0.488281L19.8359 6.22542H19.8698L20.932 0.488281H23L21.158 8.48828H18.8867L17.8696 3.44828H17.8357L16.8074 8.48828H14.536L12.7054 0.488281H14.7733L15.8243 6.22542H15.8695L16.9543 0.488281H18.7511Z'
        fill='white'
      />
    </svg>
  );
};

export default NewSvg;
